/**
 * Global application constants.
 */

export const QR_CODE_BACKEND_URL = 'https://backend.qr.cevi.tools';
export const APP_USER_AGENT = 'Konekta';
